import { Injectable, inject } from '@angular/core';
import { Product } from 'src/app/core/models/Product';
import { HttpClientWrapperService } from '../http/http-client-wrapper.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiUrlService } from '../api/api-url.service';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private readonly apiUrlService = inject(ApiUrlService);
  private get productsApiUrl(): string { return this.apiUrlService.buildUrl(`/api/v1/products`); }
  private cartRefreshSubject = new BehaviorSubject<void>(undefined);
  cartRefresh$ = this.cartRefreshSubject.asObservable();

  constructor(private httpClient: HttpClientWrapperService) {}

  getCartProducts(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(`${this.productsApiUrl}/cart`);
  }

  addToCart(id: number): Observable<void> {
    return this.httpClient.post<void, number>(`${this.productsApiUrl}/${id}/cart`, id);
  }

  removeFromCart(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.productsApiUrl}/${id}/cart`);
  }

  refreshCart(): void {
    this.cartRefreshSubject.next();
  }
}
